import { AppDispatch, RootState } from 'src/store';
import { createAction } from '@reduxjs/toolkit';

import { IFilter } from '../filters/types';

import { fetchFiltersDictRequest } from './requestHandlers';

export const dictFilterLoad = createAction<IFilter[]>('dicts/filter/load');

export const loadFilterDict = () => {
  return async (dispatch: AppDispatch, getState: () => RootState): Promise<void> => {
    const state = getState();
    if (state.dicts.filters?.length) {
      return;
    }
    const data = await fetchFiltersDictRequest();
    dispatch(dictFilterLoad(data));
  };
};
